import { useState } from 'react';
import Button from '../components/Button';
import { addLady, updateLady, deleteLady } from '../firebase/services';

function Girls({ ladies, setLadies }) {
    const [isEditing, setIsEditing] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        images: []
    });
    const [searchQuery, setSearchQuery] = useState('');

    const resetForm = () => {
        setIsEditing(null)
        setFormData({ name: '', description: '', images: [] })
    }

    const handleAdd = async () => {
        try {
            if (isEditing === "new") {
                const newLady = await addLady(formData);
                setLadies([...ladies, newLady]);
            } else if (isEditing !== null) {
                const updatedLady = await updateLady(ladies[isEditing].id, formData);
                const updatedLadies = [...ladies];
                updatedLadies[isEditing] = updatedLady;
                setLadies(updatedLadies);
            }
            resetForm()
        } catch (error) {
            console.error("Error saving lady:", error);
            // Add error handling UI here
        }
    };

    const handleDelete = async (index) => {
        try {
            await deleteLady(ladies[index].id);
            const newLadies = ladies.filter((_, i) => i !== index);
            setLadies(newLadies);
        } catch (error) {
            console.error("Error deleting lady:", error);
            // Add error handling UI here
        }
    };

    const handleEdit = (lady, index) => {
        setIsEditing(index);
        setFormData(lady);
    };

    const handleImageAdd = (url) => {
        setFormData({
            ...formData,
            images: [...formData.images, url]
        });
    };

    const handleImageRemove = (index) => {
        setFormData({
            ...formData,
            images: formData.images.filter((_, i) => i !== index)
        });
    };

    // Filter ladies based on search query
    const filteredLadies = ladies.filter(lady =>
        lady.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    console.log(filteredLadies)

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h1 className="text-3xl font-bold text-white">Manage Girls</h1>
                <div className='flex w-1/2 space-x-6 justify-end'>
                    {/* Search Bar */}
                    <div className="w-full max-w-md">
                        <input
                            type="text"
                            placeholder="Search by name..."
                            className="w-full p-2 rounded bg-gray-800 text-white border border-gray-700 focus:border-pink-500 focus:outline-none"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                    <Button onClick={() => setIsEditing('new')}>Add New Girl</Button>
                </div>
            </div>


            {/* Form */}
            {isEditing !== null && (
                <div className="bg-gray-900 p-6 rounded-lg space-y-4">
                    <input
                        type="text"
                        placeholder="Name"
                        className="w-full p-2 rounded bg-gray-800 text-white"
                        value={formData.name}
                        onChange={e => setFormData({ ...formData, name: e.target.value })}
                    />
                    <textarea
                        placeholder="Description"
                        className="w-full p-2 rounded bg-gray-800 text-white"
                        value={formData.description}
                        onChange={e => setFormData({ ...formData, description: e.target.value })}
                    />
                    <div>
                        <p className="text-gray-400 text-sm mb-2">Images</p>
                        <div className="flex flex-wrap gap-2">
                            {formData.images.map((image, index) => (
                                <div key={index} className="relative">
                                    <img
                                        src={image}
                                        alt={`Uploaded image ${index + 1}`}
                                        className="w-32 h-32 object-cover rounded"
                                    />
                                    <button
                                        onClick={() => handleImageRemove(index)}
                                        className="absolute top-0 right-0 bg-red-600 text-white rounded-full p-1 text-xs"
                                    >
                                        x
                                    </button>
                                </div>
                            ))}
                        </div>
                        <input
                            type="text"
                            placeholder="Image URL (Press Enter to Add)"
                            className="w-full p-2 rounded bg-gray-800 text-white mt-2"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && e.target.value) {
                                    handleImageAdd(e.target.value);
                                    e.target.value = '';
                                }
                            }}
                        />
                    </div>
                    <div className="flex space-x-4">
                        <Button onClick={handleAdd}>Save</Button>
                        <Button variant="secondary" onClick={resetForm}>Cancel</Button>
                    </div>
                </div>
            )}

            {/* Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
                {filteredLadies.map((lady, index) => (
                    <div key={index} className="bg-gray-900 p-6 rounded-lg space-y-4">
                        <div className="aspect-[221/340] relative overflow-hidden">
                            <img
                                src={lady.images?.length >= 1 ? lady.images[0] : ""}
                                alt={lady.name}
                                className="w-full h-full object-contain transition-transform duration-300 hover:scale-110"
                            />
                        </div>
                        <h3 className="text-xl font-bold text-white">{lady.name}</h3>
                        <p className="text-gray-300">{lady.description}</p>
                        <div className="flex space-x-4">
                            <Button variant="secondary" onClick={() => handleEdit(lady, index)}>
                                Edit
                            </Button>
                            <Button variant="danger" onClick={() => handleDelete(index)}>
                                Delete
                            </Button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Girls;